import { render } from "./HyphenParagraph.vue?vue&type=template&id=40fe5532"
import script from "./HyphenParagraph.vue?vue&type=script&lang=ts"
export * from "./HyphenParagraph.vue?vue&type=script&lang=ts"
script.render = render

export default script